import { render, staticRenderFns } from "./Ministerio.vue?vue&type=template&id=522732db&scoped=true&"
var script = {}
import style0 from "./Ministerio.vue?vue&type=style&index=0&id=522732db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522732db",
  null
  
)

export default component.exports